import React, { Fragment } from 'react';

import { ImageUploadInput } from '../components/Form/ImageUploadInput/ImageUploadInput';
import { Form } from '../components/Form/Form';

import type { FC } from 'react';

export const PromotionPictures: FC = () => {
  return (
    <Fragment>
      <Form initialValues={{ name: 'my name' }}>
        <ImageUploadInput
          label="Promotion picture"
          name="image"
          displayImageUrl={true}
          aspectRatio={10 / 2}
        />
      </Form>
    </Fragment>
  );
};
